import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { NoticeForm } from '@/admin/sitecontent/NoticeForm';
import { DetailPage } from '@/admin/ui/Editor';
import { BackLink } from '@/admin/ui/NavLinks';
import { PageTitle } from '@/admin/ui/Page';

export const Route = createFileRoute('/admin/notices/new')({
  staticData: { minTier: 'SUPPORT' },
  component: NewNotice,
});

function NewNotice() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <DetailPage>
      <BackLink>
        <Link to="/admin/notices/">{t('admin.notices.backToNotices')}</Link>
      </BackLink>
      <PageTitle>{t('admin.notices.newNotice')}</PageTitle>
      <NoticeForm
        onSaved={(id) =>
          navigate({
            to: '/admin/notices/$noticeId/',
            params: { noticeId: String(id) },
          })
        }
        onCancel={() => navigate({ to: '/admin/notices/' })}
      />
    </DetailPage>
  );
}
